import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistributionGroup } from 'src/app/models/distribution-group.model';

@Component({
    selector: 'que-distribution-group-square',
    imports: [CommonModule],
    templateUrl: './distribution-group-square.html',
    styleUrls: ['./distribution-group-square.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DistributionGroupSquareComponent {
  @Input()
  name?: string='/';
  @Input()
  color?: string;
  @Input()
  size: string='50px';
}
